import * as React from 'react';
import { H2, H4 } from 'app/components/Typography';
import { Body } from 'app/components/Typography';
import { Box, LinearProgress, useTheme } from '@material-ui/core';
import { BasicAlert } from 'app/components/BasicAlert';
import parse from 'html-react-parser';
import styled from 'styled-components';

export interface ContentTitleProps {
  help_Login?: string | null;
  title?: React.ReactNode;
  description?: React.ReactNode;
  isMobile?: boolean;
  showTopProcessing?: boolean;
}
export const TitleSection = styled('div')(({ theme }) => ({
  '&.titleSection': {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: 8,
    alignSelf: 'stretch',
    width: '100%',
    '& .logoSection': {
      display: 'flex',
      paddingBottom: '24px',
      alignItems: 'flex-start',
      gap: '10px',
      alignSelf: 'stretch',
      flexDirection: 'column',
      [theme.breakpoints.down('sm')]: {
        paddingBottom: '12px',
      },
    },
  },
}));
export function ContentTitle(props: ContentTitleProps) {
  const { help_Login, title, description, isMobile, showTopProcessing } = props;
  const theme = useTheme();
  const [showHelp, setShowHelp] = React.useState<boolean>(true);
  const show_help = React.useMemo(() => {
    return (
      //!isMobile &&
      help_Login !== null &&
      help_Login !== undefined &&
      help_Login.trim() !== '' &&
      showHelp
    );
  }, [help_Login, showHelp]);
  return (
    <TitleSection theme={theme} className={'titleSection'}>
      {/* <div className={'logoSection'}>
        <LoginScreenCompanyLogo isMobile={props.isMobile} />
      </div> */}
      {!!title && (isMobile ? <H4>{title}</H4> : <H2>{title}</H2>)}
      {show_help && help_Login !== undefined && help_Login !== null && (
        <BasicAlert
          content={{
            type: 'info',
            message: parse(help_Login) as string,
            closable: true,
            variant: 'outlined',
          }}
          // showMore={true}
          // collapsedMinHeight={200}
          onClose={() => {
            setShowHelp(false);
          }}
        />
      )}
      {!!description && <Body size="small">{description}</Body>}
      {showTopProcessing && (
        <Box style={{ width: '100%' }}>
          <LinearProgress variant="query" color="primary" />
        </Box>
      )}
    </TitleSection>
  );
}
